import BaseModelAPI from '../BaseModelAPI';

export default class PutawayConfigurationList extends BaseModelAPI {

	static entity = 'putawayconfigurationlist'
	static entityName = 'putawayconfiguration';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
